import { IAnalyticsSubmission } from '../types'

export enum PCRMetricsActionTypes {
  FETCH_REQUEST = 'pcr/metrics/FETCH_REQUEST',
  FETCH_SUCCESS = 'pcr/metrics/FETCH_SUCCESS',
  FETCH_ERROR = 'pcr/metrics/FETCH_ERROR',
}

export interface IPCRMetricsState {
  isFetching: boolean
  errors?: object | string
  metricsById: Record<number, IPCRMetrics>
  metricIdsByCampaignId: Record<number, ReadonlyArray<number>>
  metricsSummaryByCampaignId: Record<number, IPCRMetricsSummary>
}

export interface IPCRMetrics extends IAnalyticsSubmission {
  purchase_amount: number
  purchase_amount_currency: string
  impressions?: number
  impressions_pct?: number
  cpm?: number
  cpv?: number
  likes?: number
  comments?: number
  shares?: number
  engagement?: number
  cpe?: number
  engagement_pct?: number
}

export interface IPCRMetricsSummary {
  count: number | null
  total_purchase_amount: number | null
  total_followers: number | null
  engagement?: number
  engagement_pct?: number
  likes?: number
  comments?: number
  shares?: number
  impressions?: number
  impressions_pct?: number
  cpv?: number
  cpm?: number
  cpe?: number
}

export interface IPCRMetricsResponse {
  items: ReadonlyArray<IPCRMetrics>
  metadata: IPCRMetricsSummary
}
